
import React from 'react';
import {
  Table,
  TableBody,
} from '@/components/ui/table';
import { Report } from '@/types/report';
import { ReportTableHeader } from './ReportTableHeader';
import { ReportTableRow } from './ReportTableRow';

type ReportsListProps = {
  reports: Report[];
  formatDate: (dateString: string) => string;
  formatTime: (dateString: string) => string;
  showTeacherDisplay?: boolean;
  showAdminColumns?: boolean;
  onReportUpdate?: () => void;
};

export const ReportsList: React.FC<ReportsListProps> = ({ 
  reports, 
  formatDate, 
  formatTime, 
  showTeacherDisplay = false,
  showAdminColumns = false,
  onReportUpdate
}) => {
  return (
    <div className="overflow-x-auto w-full">
      <Table className="w-full">
        <ReportTableHeader 
          showTeacherDisplay={showTeacherDisplay}
          showAdminColumns={showAdminColumns}
        />
        <TableBody>
          {reports.map((report) => (
            <ReportTableRow
              key={report.id}
              report={report}
              formatDate={formatDate}
              formatTime={formatTime}
              showTeacherDisplay={showTeacherDisplay}
              showAdminColumns={showAdminColumns}
              onReportUpdate={onReportUpdate}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
